import React, { useEffect, useState } from "react";
import { SearchBarProps } from "./SearchBarProps";
import { Search } from "lucide-react";
import withTranslation from "Common/withTranslation";
import { WithTranslationProps } from "../Translation/WithTranslationProps";
import { axios_helper_async } from "helpers/Axios";
import { ProductMatch } from "Common/Models/ProductMatch";
import withNotifications, { WithNotificationsProps } from "Common/withNotifications";
import { NotificationType } from "../Notifications/notificationTypes";

const SearchBar: React.FC<SearchBarProps & WithTranslationProps & WithNotificationsProps> = ({
  onFocus,
  onBlur,
  t,
  i18n,
  notifications,
}) => {
  const [text, setText] = useState<string>();
  const [products, setProducts] = useState<ProductMatch[]>([]);
  const [focus, setFocus] = useState<boolean>(false);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    setText(value);
  };

  const handleLanguageChange = (lng: string) => {};

  const getValues = async () => {
    try {
      const body = {
        match: text,
      };

      const response = await axios_helper_async<ProductMatch[]>("/SOI/Get-Products-Names-Matches", "GET", body);

      if (response && response.isSuccess) {
        if (response.data) {
          setProducts(response.data);
        }
      } else {
        notifications.showNotification("AxiosAPI.UnexpectedError", NotificationType.Error);
      }
    } catch (err: any) {
      notifications.showNotification("AxiosAPI.FailedFetch", NotificationType.Error);
    }
  };

  const handleOnFocus = () => {
    onFocus && onFocus();
    setFocus(true);
  };

  const handleOnBlur = () => {
    setTimeout(() => {
      onBlur && onBlur();
      setFocus(false);
    }, 200); // Retardo para permitir el clic antes de cerrar la lista
  };

  useEffect(() => {
    i18n.on("languageChanged", handleLanguageChange);

    return () => {
      i18n.off("languageChanged", handleLanguageChange);
    };
  }, []);

  useEffect(() => {
    if (text) {
      (async () => {
        await getValues();
      })();
    }
  }, [text]);

  return (
    <React.Fragment>
      <div className="relative flex flex-col gap-2 w-full">
        {/* Input de búsqueda */}
        <div className="relative lg:block w-full">
          <input
            type="text"
            className="py-2 pr-4 text-sm text-topbar-item bg-topbar border border-topbar-border rounded-3xl pl-8 placeholder:text-slate-400 form-control focus-visible:outline-0 w-full focus:border-blue-400"
            placeholder={t("General.SearchFor")}
            autoComplete="on"
            onFocus={handleOnFocus}
            onBlur={handleOnBlur}
            value={text}
            onChange={handleChange}
          />
          <Search className="inline-block w-4 h-4 absolute left-2.5 top-2.5 text-topbar-item" />
        </div>

        {/* Lista de coincidencias */}
        {text && focus && (
          <div className="absolute z-10 top-full mt-1 bg-white border border-gray-300 rounded-md shadow-lg w-full">
                <ul className="max-h-60 overflow-y-auto">
                    {products.length > 0 ? (
                        products.map((product, index) => (
                            <li
                                key={index}
                                className="px-4 py-2 hover:bg-gray-200 cursor-pointer"
                                onClick={() => window.location.href = `/Product?category=${product.categoryId}&product=${product.productId}`}
                            >
                                {product.name} / {product.sku}
                            </li>
                        ))
                    ) : (
                        <li className="px-4 py-2 hover:bg-gray-200">{t("General.Errors.NoMatchesFound")}</li>
                    )}
                </ul>
            </div>      
        )}
      </div>
    </React.Fragment>
  );
};

export default withNotifications(withTranslation(SearchBar));